import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_expand.svg';
import Icon, { IconProps } from './icon';

const IconExpand = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconExpand;
